import { render, staticRenderFns } from "./ClaimInformation.vue?vue&type=template&id=64a0be9b&"
import script from "./ClaimInformation.vue?vue&type=script&lang=ts&"
export * from "./ClaimInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports